import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectNotes = () => createSelector(substate, (contextState) => contextState.notes);
